export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ReInspectMini.22e7548b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};